import { css } from 'linaria';
import { media } from '../../../../../media';

export const margin = css`
	display: block;
	margin-top: 16px;

	${media.tablet} {
		margin-top: 8px;
	}
`;

export const inline = css`
	display: block;

	${media.tablet} {
		display: inline;
	}

	${media.mobile} {
		display: block;
	}
`;

export const linkStyles = css`
	text-decoration: underline;
	color: var(--text-secondary);
	cursor: pointer;

	@media (hover) {
		&:hover {
			color: var(--text-primary);
		}
	}
`;
